import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function getSearchUrl() {
  return api + 'goods/list'
}

export function searchGoods(qryConds) {
  return Vue.http.get(api + 'goods/list', { params: qryConds })
}

export function saveGoods(goods) {
  return Vue.http.post(api + 'goods/save', goods)
}

export function getRelativeImage(type, code) {
  return Vue.http.get(api + 'goods/relative_img/' + type + '/' + code, {})
}
